import { useQuery } from "@/api/utils/useQuery"
import { INote } from "@/models/note/note.types"
import { NoteParser, INoteRaw } from "@/models/note/note.parser"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { DEFAULT_QUERY_STALE_TIME } from "@/constants/general"

export interface INoteService {
  getForAccount(billingAccountId: number | null): QueryResult<INote[]>
}

class NoteServiceClass implements INoteService {
  getForAccount(billingAccountId: number | null): QueryResult<INote[]> {
    return useQuery<INoteRaw[], INote[]>({
      ...BackofficeRestQueries.account.accountNotes(billingAccountId ?? 0),
      placeholderData: [],
      useRawResponse: true,
      enabled: !!billingAccountId,
      staleTime: DEFAULT_QUERY_STALE_TIME,
      parserFn: (data) => (data ?? []).map((item) => NoteParser.toDomain(item)),
    })
  }
}

export const NoteService = new NoteServiceClass()
